import { KeyConstructor } from './keyConstructor';
const FEED_KEY = 'feed';
export const getFeedKey = KeyConstructor(FEED_KEY);
//# sourceMappingURL=feed.keys.js.map